import { cn } from "../../utils/cn"
import { Button } from "./button"
import { ChevronLeft, ChevronRight } from "lucide-react"

// Simple Calendar Widget (Mock)
export function CalendarWidget({ className }) {
  const days = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"]
  
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('it-IT', { month: 'long' });
  const currentYear = currentDate.getFullYear();
  const capitalizedMonth = currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1);
  const today = currentDate.getDate();

  // Mock dates for current month
  const dates = Array.from({ length: 30 }, (_, i) => i + 1)
  
  return (
    <div className={cn("p-3", className)}>
      <div className="flex items-center justify-between space-y-2 mb-4">
        <div className="font-semibold text-sm">{capitalizedMonth} {currentYear}</div>
        <div className="space-x-1 flex">
            <Button variant="outline" size="icon" className="h-7 w-7"><ChevronLeft className="h-4 w-4" /></Button>
            <Button variant="outline" size="icon" className="h-7 w-7"><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center text-xs mb-2">
        {days.map(day => <div key={day} className="text-muted-foreground font-medium">{day}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1 text-center text-sm">
        {/* Empty slots for start of month */}
        <div className="p-2"></div>
        <div className="p-2"></div>
        {dates.map(date => (
            <div key={date} className={cn(
                "p-2 rounded-md cursor-pointer hover:bg-accent",
                date === today ? "bg-primary text-primary-foreground hover:bg-primary" : "",
                date === 15 || date === 22 ? "relative after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-1 after:rounded-full after:bg-primary" : ""
            )}>
                {date}
            </div>
        ))}
      </div>
    </div>
  )
}
